import styled, { css } from 'styled-components';

import ChevronDownIcon from '@ad-scripts/presentation/components/lib/icons/chevron_down_icon';

const transition = css`
  transition-duration: 0.4s;
  transition-property: transform;
`;

const flipChevron = css`
  transform: rotate(0deg);
  ${transition}
`;

export const ChevronIcon = styled(ChevronDownIcon)`
  transform: rotate(-90deg);
  ${transition}

  stroke: ${p => (p.disabled ? p.theme.colors.gray300 : p.theme.colors.gray600)};
  fill: ${p => (p.disabled ? p.theme.colors.gray300 : p.theme.colors.gray600)};
  height: 16px;
  width: 13px;
  line-height: 0;

  ${p => p['data-isopen'] && flipChevron};
`;
